import { render, staticRenderFns } from "./Shareholder.vue?vue&type=template&id=6ca32b94&scoped=true"
import script from "./Shareholder.vue?vue&type=script&lang=js"
export * from "./Shareholder.vue?vue&type=script&lang=js"
import style0 from "./Shareholder.vue?vue&type=style&index=0&id=6ca32b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca32b94",
  null
  
)

export default component.exports